/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairSearchMoreFlightsParameters } from '../../models/finnair-search-more-flights-parameters';
import { MultiOfferList } from '../../models/multi-offer-list';

export interface FindMoreFlights$Params {
  hash: string;
      body: FinnairSearchMoreFlightsParameters
}

export function findMoreFlights(http: HttpClient, rootUrl: string, params: FindMoreFlights$Params, context?: HttpContext): Observable<DapiHttpResponse<MultiOfferList>> {
  const rb = new DapiRequestBuilder(rootUrl, findMoreFlights.PATH, 'post');

  if (params) {
    rb.query('hash', params.hash, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<MultiOfferList>;
    }),
    catchErrorAsJson()
  );
}

findMoreFlights.PATH = '/api/multi/moreFlights';
